import React from 'react';

export const CameraCategory = (props) => (
    <svg {...props} viewBox="0 0 26 25" fill="none">
        <path d="M16 10.1C16 11.8 14.7 13.1 13 13.1C11.3 13.1 10 11.8 10 10.1C10 8.39995 11.3 7.09995 13 7.09995C14.7 7.09995 16 8.39995 16 10.1ZM24.8 20.9L23 19.1V10.4C23 5.39995 19.4 0.899951 14.5 0.199951V3.19995C17.6 3.89995 20 6.69995 20 10.1C20 14 16.9 17.1 13 17.1C9.1 17.1 6 14 6 10.1C6 6.69995 8.4 3.99995 11.5 3.29995V0.199951C6.7 0.899951 3 5.09995 3 10.1V19.1L1.2 20.9C0.4 21.7 0 22.7 0 23.7V25H3H23H26V23.7C26 22.7 25.6 21.7 24.8 20.9Z" />
    </svg>
);
export default CameraCategory;
